import { apiConstatnts } from "constants/apiConstants";
import { store } from "store";
import { UserUpdateInfo } from "types/user";
import httpRequset from "utils/HttpRequest";
import { compressImage } from "utils/compressImage";
import queryString from "query-string";

const { REACT_APP_API_URL, REACT_APP_ACCESS_TOKEN } = process.env;

type GetUserVouchersParams = {
  isGrouped?: boolean;
  language?: "en" | "tc";
};

async function getUserPoints() {
  try {
    const user = store.getState().auth.user;

    const url = `${REACT_APP_API_URL}/point/user/${String(user!["user_id"])}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
}

async function updateUserInfo(params: UserUpdateInfo, image: File | null) {
  try {
    let compressedImage = null;

    const url = `${REACT_APP_API_URL}/user/update`;

    const myHeaders = new Headers();

    myHeaders.append("authorization", `Bearer ${REACT_APP_ACCESS_TOKEN}`);

    const formData = new FormData();

    formData.append("user_id", store.getState().auth.user!["user_id"]);

    Object.keys(params).forEach(function (key: string) {
      if (params[key as keyof UserUpdateInfo] != null) {
        formData.append(key, String(params[key as keyof UserUpdateInfo]));
      }
    });

    if (image) {
      compressedImage = await compressImage(image);
      formData.append("personal-image", compressedImage);
    }

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions as any);

    const rawData = await response.text();

    const data = JSON.parse(rawData);

    if (data?.statusCode !== 200) throw new Error(data?.message || "Error");

    return data.data;
  } catch (error) {
    throw error;
  }
}

async function getUserMembership() {
  try {
    const user = store.getState().auth.user;

    const url = `${REACT_APP_API_URL}/membership/user/${user!["user_id"]}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
}

async function getUserVouchers(params?: GetUserVouchersParams) {
  try {
    const user = store.getState().auth.user;

    const query = params ? `?${queryString.stringify(params)}` : "";
    const url = `${REACT_APP_API_URL}/voucher/user/get-user-vouchers/${user!["user_id"]}${query}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
}

const getUserInfo = async () => {
  try {
    const user = store.getState().auth.user;

    const url = `${REACT_APP_API_URL}/user/details/${user!["user_id"]}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
};

export const userService = {
  getUserPoints,
  updateUserInfo,
  getUserMembership,
  getUserVouchers,
  getUserInfo,
};
